import React, { useEffect } from 'react';
import { Form, Input, Col, Row } from 'antd';

interface Iprops {
  compnyNm: string;
  accNm: string;
}

const HeaderRow2 = (props: Iprops) => {
  const [form] = Form.useForm();

  //初期化処理
  useEffect(() => {
    const init = async () => {
      form.setFieldsValue({
        i_compny_nm: props.compnyNm,
        i_acc_nm: props.accNm,
      });
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form form={form}>
      <Row
        style={{
          backgroundColor: '#69c0ff',
          height: '45px',
          paddingTop: '5px',
        }}
      >
        <Col offset={1} md={3} xs={4}>
          <Form.Item label="ログインID"></Form.Item>
        </Col>
        <Col lg={8} xs={10}>
          <Form.Item name={'i_compny_nm'}>
            <Input className="clsReadOnly" maxLength={20} readOnly={true} />
          </Form.Item>
        </Col>
        <Col lg={5} xs={8}>
          <Form.Item name={'i_acc_nm'}>
            <Input className="clsReadOnly" maxLength={10} readOnly={true} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default HeaderRow2;
